import styled from 'styled-components';
import { AsideEntityDetails, VideoPosterEntityDetails } from 'app/components/Entity';

/* eslint-disable-next-line */
export const AsideEventDetails = styled(AsideEntityDetails).attrs({
  className: 's-event__details-aside'
})`
  .s-event-details__aside-img {
    width: 100%;
  }
  a{
    color:#DE1619;
    text-decoration:underline;
  }
`;
// export const AsideEventDetails = styled(AsideEntityDetails).attrs({
//   className: 's-event__details-aside'
// })`
//   .s-event-details__aside-img {
//     width: 100%;
//   }
// `;
